import { createI18n } from 'vue-i18n';
import { plgPlanSDK } from '../../index';
import { getCurrentLanguage } from '@eureka/language-tool';
import type { PlgPlanSDKOpenOptions, PlgPlanSDKOptions } from '../types';
import { tryOnBeforeMount } from '@vueuse/core';
import { removeAuthToken } from '../utils';
import _ from 'lodash';
import { _passportDeferred } from '@eureka/startup/src/enable-token-base';

export function usePlgPlanSdk(options?: PlgPlanSDKOptions & { router?: any; route?: any }) {
    plgPlanSDK.setI18n(options?.i18n || createI18n({
        locale: getCurrentLanguage(),
        legacy: false,
    }))

    // 处理支付成功回调
    if (options?.router && options?.route) {
        tryOnBeforeMount(async() => {
            const { payment_state } = options.route.query;
            if (payment_state === 'success') {
                removeAuthToken()
                localStorage.removeItem('patsnap_header_account_info')
                try {
                    const _passport = await _passportDeferred.promise;
                    if (!_passport) throw new Error('passport is not setup!')
                    _passport?.removeLocal()
                } catch (error) {
                    console.error('[Use Plg Plan SDK]', 'passport is not setup!')
                }
                console.warn('[Use Plg Plan SDK]', '尝试刷新token')
                plgPlanSDK.openSuccessDialog()
                options.router.replace({
                    query: {
                        ..._.omit(options.route.query, ['payment_state']),
                    },
                })
            }
        })
    }

    function openPlgPlanDialog(options?: PlgPlanSDKOpenOptions) {
        plgPlanSDK.openPlgPlanDialog(options)
    }

    function openSuccessDialog() {
        plgPlanSDK.openSuccessDialog()
    }

    return {
        openPlgPlanDialog,
        openSuccessDialog,
    }
}
